import { useMutation, useQueryClient } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';
import { FINDING_BY_ID_QUERY_KEY } from './useFindingById';
import { FINDINGS_QUERY_KEY } from './useFindings';
import { FINDING_AUDIT_LOGS_QUERY_KEY } from '../useFindingAuditLogs';
import { FINDING_TIMELINE_QUERY_KEY } from '../useFindingTimeline';

export const useAbortFindingRetest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      findingId,
      threadId,
      executionId,
    }: {
      findingId: string;
      threadId?: string;
      executionId?: string;
    }) =>
      terraProxyApiClient.abortFindingRetest({
        findingId,
        threadId,
        executionId,
      }),
    onMutate: async ({ findingId }) => {
      await Promise.all([
        queryClient.cancelQueries({
          queryKey: [FINDING_BY_ID_QUERY_KEY, findingId],
          exact: false,
        }),
        queryClient.cancelQueries({
          queryKey: [FINDING_AUDIT_LOGS_QUERY_KEY, findingId],
          exact: false,
        }),
        queryClient.cancelQueries({
          queryKey: [FINDING_TIMELINE_QUERY_KEY, findingId],
          exact: false,
        }),
      ]);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [FINDING_BY_ID_QUERY_KEY, variables.findingId],
        exact: false,
      });
      void queryClient.invalidateQueries({
        queryKey: [FINDINGS_QUERY_KEY],
        exact: false,
      });
      void queryClient.invalidateQueries({
        queryKey: [FINDING_AUDIT_LOGS_QUERY_KEY, variables.findingId],
        exact: false,
      });
      void queryClient.invalidateQueries({
        queryKey: [FINDING_TIMELINE_QUERY_KEY, variables.findingId],
        exact: false,
      });
    },
  });
};
